// TODO add type for data
export const saveFiltersToStorage = (key: string, data: any): void => {
	localStorage.setItem('pageFilters', JSON.stringify({ [key]: data }));
};
export const removeFiltersFromStorage = (): void => {
	localStorage.removeItem('pageFilters');
};
export const getFiltersFromStorage = (): any => {
	return localStorage.getItem('pageFilters');
};
export const getFilterKey = (): string | null => {
	const data = getFiltersFromStorage();
	if (!data) return null;
	const key = Object.keys(data)?.[0];
	return key;
};

export const saveFavoriteFiltersToStorage = (key: string, data: any): void => {
	const existingData = getFavoriteFiltersFromStorage();
	if (existingData) {
		localStorage.setItem('pageFavoriteFilters', JSON.stringify({ ...existingData, [key]: data }));
	} else {
		localStorage.setItem('pageFavoriteFilters', JSON.stringify({ [key]: data }));
	}
};

export const getFavoriteFiltersFromStorage = (key?: string): any => {
	const data = localStorage.getItem('pageFavoriteFilters');

	if (data) {
		const parsedData = JSON.parse(data);
		if (key) {
			return parsedData[key];
		}
		return parsedData;
	}

	return null;
};

export const removeFavoriteFiltersFromStorage = (): void => {
	localStorage.removeItem('pageFavoriteFilters');
};

export const removeFilters = (name: string): void => {
	const filters = JSON.parse(getFiltersFromStorage());
	if (filters) {
		delete filters[name];
		saveFiltersToStorage(name, filters);
	}
};
